import { PaymentService } from './../../core/services/payment.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctionsService } from 'app/core/services';
import { Course, CourseTemplate, Region } from 'app/shared/models';

@Component({
  moduleId: module.id,
  selector: 'fo-courses',
  templateUrl: './courses.page.html'
})
export class CoursesPage implements OnInit {
  today: any = new Date().toJSON();

  // Course filter
  courseTemplates: CourseTemplate[];
  filteredCourseTemplates: CourseTemplate[];
  selectedCourseTemplate: CourseTemplate;

  // Region filter
  regions: Region[];
  filteredRegions: Region[];
  selectedRegion: Region;

  // Course list
  courses: Course[];
  coursesFullCount = 0;
  filteredCourses: Course[];
  loadingCourses = false;
  selectedCourse: Course;

  constructor(
    private globalFunctionsService: GlobalFunctionsService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private payment: PaymentService
  ) {
    this.globalFunctionsService.showBasket(true);
    this.globalFunctionsService.showTabs(true);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    // Initialize filters
    this.selectedCourseTemplate = null;
    this.selectedRegion = null;

    // Load data from route
    this.courseTemplates = this.route.snapshot.data['courseTemplates'];
    const templateIds = this.courseTemplates.map((template: CourseTemplate) => template.Id);
    this.courses = this.filteredCourses = this.route.snapshot.data['courses'].filter(
      (course: Course) => templateIds.includes(course.TemplateId) && !course.IsFull
    );
    this.regions = this.filteredRegions = this.route.snapshot.data['regions'];

    // Preselect using query parameters if provided
    const courseIdParam = this.route.snapshot.queryParams['cid'];
    const templateIdParam = this.route.snapshot.queryParams['tid'];
    if (courseIdParam) {
      const courseFromParam = this.courses.find(course => course.Id === parseInt(courseIdParam, 10));
      if (courseFromParam && !courseFromParam.IsFull) {
        this.selectCourse(courseFromParam);
        this.selectedCourseTemplate = this.courseTemplates.find(
          template => template.Id === this.selectedCourse.TemplateId
        );
        this.selectedRegion = this.regions.find(region => region.Id === this.selectedCourse.RegionId);
      }
    }
    if (!this.selectedCourse && templateIdParam) {
      this.selectedCourseTemplate = this.courseTemplates.find(
        template => template.Id === parseInt(templateIdParam, 10)
      );
    }
    if (!this.selectedCourseTemplate) {
      // If returning from previous selection
      this.selectedCourse = this.globalFunctionsService.getSelectedCourse();
      if (this.selectedCourse) {
        // Prefill selected course
        this.selectedCourseTemplate = this.globalFunctionsService.selectedCourseTemplate;
        this.selectedRegion = this.globalFunctionsService.selectedRegion;
      }
    }

    // Apply initial filters and sort courses
    this.updateFilters();

    // Set App Initialized
    this.globalFunctionsService.appInitialized = true;
  }

  updateFilters(): void {
    this.loadingCourses = true;

    // Save filters
    this.globalFunctionsService.selectedCourseTemplate = this.selectedCourseTemplate;
    this.globalFunctionsService.selectedRegion = this.selectedRegion;

    // Apply course template filter
    if (!this.selectedCourseTemplate) {
      this.filteredCourses = this.courses;
    } else {
      const templateId = this.selectedCourseTemplate.Id;
      this.filteredCourses = this.courses.filter(course => course.TemplateId === templateId);
    }

    // Update and apply region filter
    const regionIds: string[] = this.filteredCourses.map(course => course.RegionId);
    this.filteredRegions = this.regions.filter(region => regionIds.includes(region.Id));

    if (this.filteredRegions.includes(this.selectedRegion)) {
      this.filteredCourses = this.filteredCourses.filter(
        (course: Course) => course.RegionId === this.selectedRegion.Id
      );
    } else {
      this.selectedRegion = null;
    }

    // Sort filtered courses by name followed by date
    this.filteredCourses = this.filteredCourses.sort(this.sortByDateThenName);

    this.loadingCourses = false;
  }

  selectCourse(course: Course, toggleMobile = false): void {
    if (course.IsFull) {
      return;
    }
    if (this.selectedCourse === course && toggleMobile) {
      this.selectedCourse = null;
    } else {
      this.selectedCourse = course;
      this.globalFunctionsService.updateSelectedCourse(course);
      this.globalFunctionsService.enableTabs(2);
    }
  }

  enroll(course: Course): void {
    if (course) {
      this.selectedCourse = course;
      this.globalFunctionsService.updateSelectedCourse(course);
      this.globalFunctionsService.enableTabs(2);
    }
    if (this.selectedCourse.IsFull) {
      return;
    }
    window.scrollTo(0, 0);
    this.router.navigate(['students']);
  }

  sortByDateThenName(a: Course, b: Course): number {
    if (a.Date < b.Date) {
      return -1;
    }
    if (a.Date > b.Date) {
      return 1;
    }
    if (a.Name < b.Name) {
      return -1;
    }
    if (a.Name > b.Name) {
      return 1;
    }
    return 0;
  }
}
